import { FabricObject } from "fabric";

// pour qu'un clip garde ses proportions sur un objet étendu,
// on va réduire l'échelle de la partie la plus longue proportionnellement à la plus courte

const antiScale = (obj: FabricObject) => {
  const ratio = obj.scaleY / obj.scaleX;
  return ratio < 1 ? [ratio, 1] : [1, 1 / ratio];
};

export default antiScale;

